import React from 'react';
const SubscribeSection = () => {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-455">
      <div className="absolute inset-0 bg-[#f8f9f4] skew-y-3 transform origin-top-left" data-id="element-456"></div>
      {/* Decorative elements */}
      <div className="absolute left-0 bottom-0 w-40 h-40 opacity-10" data-id="element-457">
        <img src="https://images.unsplash.com/photo-1600857544200-b2f468e9d10d?q=80&w=200&auto=format&fit=crop" alt="Leaf decoration" className="w-full h-full object-cover" onError={e => {
        e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=200&auto=format&fit=crop';
      }} data-id="element-458" />
      </div>
      <div className="absolute right-0 bottom-0 w-40 h-40 opacity-10" data-id="element-459">
        <img src="https://images.unsplash.com/photo-1601055283742-8b27e81b5553?q=80&w=200&auto=format&fit=crop" alt="Leaf decoration" className="w-full h-full object-cover transform scale-x-[-1]" onError={e => {
        e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=200&auto=format&fit=crop';
      }} data-id="element-460" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-461">
        <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-xl p-10 text-center" data-id="element-462">
          <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-463">
            <span data-id="element-464">Join Our Community</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-465">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-466">
            Stay updated with our latest products, exclusive offers, and
            wellness tips.
          </p>
          <form className="flex flex-col sm:flex-row gap-3" data-id="element-467">
            <input type="email" placeholder="Your email address" className="flex-1 px-5 py-3.5 border border-gray-300 rounded-lg focus:outline-none focus:border-[#2e7d32] focus:ring-1 focus:ring-[#2e7d32]" required data-id="element-468" />
            <button type="submit" className="px-6 py-3.5 bg-[#2e7d32] text-white font-medium rounded-lg uppercase hover:bg-[#1b5e20] transition-colors duration-300 whitespace-nowrap" data-id="element-469">
              Subscribe
            </button>
          </form>
          <p className="text-xs text-gray-500 mt-4" data-id="element-470">
            By subscribing, you agree to our Privacy Policy. You can unsubscribe
            at any time.
          </p>
        </div>
      </div>
    </section>;
};
export default SubscribeSection;